import React, { useContext } from 'react'

import { getFlagImage } from '@/components/layouts/main-layout/components/header/components/main-menu/utils'
import InternationalizationContext from '@/context/internationalization/context'

import CurrencyChip from './currency-chip'

const FiltersCurrency: React.FC = () => {
    const {
        state: { data },
        selectors: { selectedCurrency },
        dispatch: { selectCurrency },
    } = useContext(InternationalizationContext)

    const handleClick = (selectedOption: string) => selectCurrency(selectedOption)

    return (
        <div data-testid="filters-currency">
            {data?.countries?.map((country, index) => {
                if (data?.availableCurrencies?.includes(country.currencyDefault)) {
                    return (
                        <CurrencyChip
                            key={index}
                            label={country.currencyDefault}
                            flag={getFlagImage(country.countryCode)}
                            isSelected={country.currencyDefault === selectedCurrency}
                            onClick={handleClick}
                        />
                    )
                }
            })}
        </div>
    )
}

export default FiltersCurrency
